import React from "react";
import "./ProfileHeader.scss";
import { withFirebase } from "components/Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import Button from "components/Button";
import Avatar from "components/Avatar";

const INITIAL_STATE = {
  user: {
    firstName: "",
    lastName: "",
    location: "",
    description: "",
    userName: ""
  },
  isEditable: false
};

const EditableSection = ({
  activate,
  isEditable,
  save,
  discard,
  children,
  title
}) => {
  return (
    <div className="EditableSection" data-editable={isEditable}>
      <div className="head">
        <h6>{title}</h6>
      </div>
      <div className="content">{children}</div>
    </div>
  );
};

// const VisitorActions = () => (
//   <>
//     <Button type="primary">Follow</Button>
//     <Button icon type="primary">
//       <i className="ion ion-ios-chatbubbles" />
//     </Button>
//     <Button icon type="primary">
//       <i className="ion ion-ios-share-alt" />
//     </Button>
//   </>
// );

const UserActions = () => (
  <>
    <Button to="/settings" type="primary">
      Edit Profile
    </Button>
    <Button to="/create-project" type="primary">
      Create Project
    </Button>
  </>
);

class ProfileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };
  }
  componentDidMount() {
    if (this.props.user) {
      this.setState({ user: this.props.user });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.user.firstName !== this.props.user.firstName) {
      this.setState({ user: this.props.user });
    }
  }
  activateEditMode = () => {
    this.setState({ isEditable: true });
  };

  render() {
    const { isMyProfile, loaded } = this.props;
    const {
      firstName,
      lastName,
      location,
      description,
      userName,
      picture
    } = this.state.user;

    return (
      <div className="ProfileHeader" data-loaded={loaded}>
        <div className="hero" data-image={picture ? true : false}>
          {picture && <Avatar size={96} image={picture} />}
          <div className="core">
            <h6>@{userName}</h6>
            <h4>
              {firstName} {lastName}
            </h4>
            <h5>{location}</h5>
          </div>
        </div>
        <EditableSection title="Biography">
          <p>{description}</p>
        </EditableSection>
        <div className="actions">
          {/* {isMyProfile ? <UserActions /> : <VisitorActions />} */}
          {isMyProfile ? <UserActions /> : null}
        </div>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withFirebase
)(ProfileHeader);
